import styled, { css } from 'styled-components';
import { shakeKeyframes } from '../../../styles/keyframes';

interface IInsertPasswordMessageProps {
  animation: boolean;
}

export const PasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 1rem;
`;

export const InsertPasswordMessage = styled.p<IInsertPasswordMessageProps>`
  margin-bottom: 1.5rem;
  text-align: center;

  ${props =>
    props.animation &&
    css`
      animation: ${shakeKeyframes} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97)
        both;
      transform: translate3d(0, 0, 0);
    `}
`;
